<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import ProductsTable from '@components/retina/products/productsTable'
import { productsMethods } from '@state/helpers'

export default {
  name: 'Benchmark',
  page: {
    title: 'Benchmark',
    meta: [
      {
        name: 'Benchmark',
        content: 'Benchmark',
      },
    ],
  },
  components: { Layout, PageHeader, ProductsTable },
  data() {
    return {
      title: '<i class="fas fa-clipboard"></i> Configuración de reportes',
      items: [
        {
          text: 'Reportes',
        },
        {
          text: 'Configuración de reportes',
          active: true,
        },
      ],
      tableHeaders: [
        {
          key: 'reference',
          label: 'Referencia',
          class: 'd-none d-lg-table-cell',
        },
        { key: 'name', label: 'Producto' },
        { key: 'extension', label: 'Extensión' },
        { key: 'actions', label: '', class: 'w-25' },
      ],
    }
  },
  methods: {
    ...productsMethods,
    myProvider(ctx) {
      let context = this
      const promise = context.fetchProductsToList(this.$table_params(ctx))
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          return []
        })
    },
    redirectConfigBenchmark(item) {
      this.selectProduct(item)
      this.$router.push('/reports/benchmark-config')
    },
    redirectConfigConsolidated(item) {
      this.selectProduct(item)
      this.$router.push('/reports/consolidated-config')
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="bg-white p-2">
      <h4>Lista de Productos</h4>
      <p class="text-justify">
        Por cada producto podemos establecer un
        <strong>máximo por ubicación</strong
        ><i class="fas fa-chart-line ml-1"></i> o un
        <strong>consolidado por bodegas</strong
        ><i class="fas fa-chart-area ml-1"></i>
      </p>
      <ProductsTable
        :tableheaders="tableHeaders"
        :drfprovider="myProvider"
        :enableQrSearch="false"
        :enabledWarehouseMultiselect="false"
      >
        <template v-slot:cell(extension)="data">
          {{ data.item.id_ext1 }} {{ data.item.ext_description }}
        </template>
        <template v-slot:cell(actions)="data">
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none text-info"
            no-caret
            right
          >
            <template #button-content>
              <i class="fas fa-cog fa-lg text-info"></i>
              <span class="d-none d-md-inline"> Opciones</span>
            </template>
            <b-dropdown-item-button @click="redirectConfigBenchmark(data.item)">
              <i class="fas fa-chart-line mr-1"></i> Establecer Máximo
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="redirectConfigConsolidated(data.item)">
              <i class="fas fa-chart-area mr-1"></i> Establecer Consolidado
            </b-dropdown-item-button>
          </b-dropdown>
        </template>
      </ProductsTable>
    </div>
  </Layout>
</template>
